<template>
	<div class="aside_right">
		<div class="teplate_tit">
			<div class="teplate_tits">
				<div @click="saveId"> + 制作内容</div>
			</div>
			<div class="conlist clearfix" v-if="formData.tamplate_id==1" v-for="(item,key) in inforShow" @click="xgContent($event,key)" v-cloak>
				<div class="list_tit clearfix">
					<div class="tits fl_left">{{item.json_data.bg_title}}</div>
					<div class="music_icon fl_left">
						<div class="music fl_left" v-if="item.json_data.music" v-for="(itemMusic,keyMusic) in item.json_data.music" @click="play($event,key,keyMusic)"> 
							<audio :src="itemMusic.src" class="play"></audio>
						</div>
					</div>
					<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)"  v-if="item.is_detail == 1">
						<span>教学详解</span>
					</div>
					<div class="xq_box" @click.stop="xgContent">
						<div class="xq_del" @click="xq_hide($event)"></div>
						<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
							<div class="clearfix">
								<div class="xqTit fl_left">{{itemBkxq.title}}</div>
								<div class="music_icon fl_left">
									<div class="music fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.music" @click="plays($event,key,ky,keysMusic)"> 
										<audio :src="itemMusicq.src" class="play"></audio>
									</div>
								</div>
							</div>
							<div class="xqCon" v-for="BkxqTxt in itemBkxq.list" >
								<div v-if="BkxqTxt.content" v-html="BkxqTxt.content">{{BkxqTxt.content}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="list_wb">
					<div class="wb_con">
						<div class="wb_tit" v-html="item.json_data.bg_text">{{item.json_data.bg_text}}</div>
					</div>
				</div>
			</div>
		</div>
		<div class="mark_wrap" v-if="lmcon">
			<div class="tishi_Infor">
				<div class="tishi_con">请先添加左侧栏目</div>
				<div class="tishi_btn" @click="sure">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
//import './../../static/js/videoPlay.js'
	export default{
		data(){
			return{
				// isActive:0,
				// music_state:0,
				// feomLsit:this.formData,
				inforShow:[],
				inforShow1:[],
				lmcon:false,
				package:'',
				id:'',
				table_id:'',
			}
		},
		props:['formData'],
		methods:{
			xgContent(e,i){
				e.stopPropagation();
				const _this = this;
				console.log(this.formData)
				localStorage.setItem('template',JSON.stringify(this.formData));

				if(sessionStorage.getItem('changeName') == null){
					// var tep_crey=JSON.stringify(this.formData);
					sessionStorage.setItem('formID',JSON.stringify({crey:_this.formData.module_id,conId:_this.inforShow[i].id}))
					// _this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/addCategory/centersCon/index/makFrom/startFrom',
						query:{
							course_id:this.formData.course_id,
							// package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							package_id:this.$route.query.package_id
						}
					})
				}else{
					sessionStorage.setItem('formID',JSON.stringify({crey:parseInt(sessionStorage.getItem('changeName')),conId:_this.inforShow[i].id}))
					this.formData.module_id = parseInt(sessionStorage.getItem('changeName'))
					// var tep_crey=JSON.stringify(this.formData);
					// _this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/addCategory/centersCon/index/makFrom/startFrom',
						query:{
							course_id:this.formData.course_id,
							// package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							package_id:this.$route.query.package
						}
					})
				}
			},
			sure(){
				this.lmcon=! this.lmcon
			},
			xq_hide(e){
				e.stopPropagation();
				$('.xq_box').hide()
			},
			xq_show(e,i){
				e.stopPropagation();
				$('.xq_box').show();
				$('.conlist').find('.music_icon').find('.music').removeClass('zcir')
				for(var a=0;a<$('.conlist').find('.music_icon').find('.music').length;a++){
					for(var b=0;b<$('.conlist').find('.music_icon').find('.music').eq(a).find('.play').length;b++){
						$('.conlist').find('.music_icon').find('.music').eq(a).find('.play')[b].pause();
					}
				}
				let _this = this ;
				_this.$axios.post('showmodtwo',{to_id:_this.inforShow[i].id}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow1 = res.data.data[0].json_data.detal
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
				// this.$axios.post('showmodtwo',{
				// 	to_id:this.XQtoId[i]
				// }).then(({data:{data}})=>{
				// 	this.inforShow1=eval('('+data[0].json_data+')').detal
				// })
				if(typeof($(document).find('video')[0])== 'object'){
					$(document).find('video')[0].pause()
				}
			},
			saveId(){
				const _this = this;
				sessionStorage.removeItem('formID')
				// var tep_crey=;
				console.log(this.formData)
				localStorage.setItem('template',JSON.stringify(this.formData));
				if(sessionStorage.getItem('changeName') == null){
					// var tep_crey=JSON.stringify(this.formData);
					// _this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);

					if(_this.formData.lanmu <= 0){
				 		_this.lmcon = true;
				 	}else{
				 		_this.lmcon = false;
				 		_this.$router.push({
							path:'/manager/addCategory/centersCon/index/makFrom/startFrom',
							query:{
								course_id:this.formData.course_id,
								// package:this.$route.query.package_id,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								package_id:this.$route.query.package_id
							}
						})
				 	}
				}else{
					this.formData.module_id = parseInt(sessionStorage.getItem('changeName'))
					
					// _this.formData.course_id = _this.$md5("'"+this.formData.course_id+"'")
					
					if(_this.formData.lanmu <= 0){
				 		_this.lmcon = true;
				 	}else{
				 		_this.lmcon = false;
				 		_this.$router.push({
							path:'/manager/addCategory/centersCon/index/makFrom/startFrom',
							query:{
								course_id:this.formData.course_id,
								// package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								package_id:this.$route.query.package_id
							}
						})
				 	}
				}
			},
			play(e,i,j){
				e.stopPropagation();
				$('.conlist').eq(i).siblings().find('.music_icon').find('.music').removeClass('zcir');
				for(var a=0;a<$('.conlist').eq(i).siblings().find('.music_icon').find('.music').length;a++){
					for(var b=0;b<$('.conlist').eq(i).siblings().find('.music_icon').find('.music').eq(a).find('.play').length;b++){
						$('.conlist').eq(i).siblings().find('.music_icon').find('.music').eq(a).find('.play')[b].pause();
					}
				}
				if($('.conlist').eq(i).find('.list_wb').find('.wb_con').children('.wb_tit').find('p').children('video').length>0){
					$('.conlist').eq(i).find('.list_wb').find('.wb_con').children('.wb_tit').find('p').children('video')[0].pause()
				}
				$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).find('.play').each(function(){       
					$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).find('.play')[0].pause();       
				    $('.conlist').eq(i).find('.music_icon').find('.music').eq(j).find('.play')[0].currentTime = 0.0;    
				});
				if($('.conlist').eq(i).find('.music_icon').find('.music').eq(j).hasClass('zcir')){
					$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).removeClass('zcir').find('.play')[0].pause();
				}
				else{
					$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).addClass('zcir').find('.play')[0].play();
					for(var m=0;m<$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).siblings().find('.play').length;m++){
						$('.conlist').eq(i).find('.music_icon').find('.music').eq(j).siblings().removeClass('zcir').find('.play')[m].pause();
					}
				}	
			},
			plays(e,i,j,l){
				e.stopPropagation();
				$('.conlist').eq(i).siblings().find('.music_icon').find('.music').removeClass('zcir');
				$('.conlist').eq(i).find('.xq_list').eq(j).siblings().find('.music_icon').find('.music').removeClass('zcir');
				for(var a=0;a<$('.conlist').eq(i).siblings().find('.music_icon').find('.music').length;a++){
					for(var b=0;b<$('.conlist').eq(i).siblings().find('.music_icon').find('.music').eq(a).find('.play').length;b++){
						$('.conlist').eq(i).siblings().find('.music_icon').find('.music').eq(a).find('.play')[b].pause();
					}
				}
				$('.music').children('.play').get(0).pause()
				$('.music').removeClass('zcir')
				$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play').each(function(){       
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play')[0].pause();       
				   	$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).find('.play')[0].currentTime = 0.0;    
				});
				if($('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).hasClass('zcir')){
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).removeClass('zcir').find('.play')[0].pause();
				}
				else{
					$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).addClass('zcir').find('.play')[0].play();
					for(var m=0;m<$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).siblings().find('.play').length;m++){
						$('.conlist').eq(i).find('.xq_list').eq(j).find('.music').eq(l).siblings().removeClass('zcir').find('.play')[m].pause();
					}
				}	
			},
			changeRightCon(){
				var _this=this;
				if(sessionStorage.getItem('changeName') != null){
					_this.$axios.post('showmodone',{
						tm_id:parseInt(sessionStorage.getItem('changeName'))
					}).then( res =>{
						if(res.data.code == 200){
							_this.inforShow = res.data.data
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})
				}
				else{
					_this.$axios.post('showmodone',{
						tm_id:_this.formData.module_id
					}).then( res =>{
						if(res.data.code == 200){
							_this.inforShow = res.data.data
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})
				}
			}
		},
		created(){
			var _this=this;
			_this.changeRightCon()
		},
		watch:{
			formData:{
				 handler(){
				 	var _this=this;
					 $('.xq_box').hide()
					 _this.changeRightCon()
				 },
				 deep:true	
			}
		}
	};
</script>
<style scoped>
	.aside_right{
		width: 100%;
		box-sizing: border-box;
		margin-top: 20px;
		min-height: 514px;
		overflow:auto;
		background: rgba(134, 141, 205, 0.95);
		padding:20px 0 0 32px;
		position: relative;
		font-size: 18px;
		overflow-y: auto;
	}
	.teplate_tits{
		width: 148px;
		height: 44px;
		box-sizing: border-box;
		line-height: 44px;
		text-align: center;
		color: #fff;
		border-radius: 6px;
		border:1px dashed #fff;
		font-size: 16px;
		cursor: pointer;
	}
	.teplate_tit{
		overflow-y:auto;
		height: 494px;
	}
	.teplate_tit::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.teplate_tit::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.teplate_tit::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.aside_right::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.aside_right::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.aside_right::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.list_tit{
		color: #fff;
	}
	.list_wb{
		color: #fff;
		min-width:725px;
		width: 95%;	}
	.list_wb .wb_tit{
		margin-bottom: 10px;
		font-size: 20px;
	}
	.list_wb .wb_tit img{
		display: inline-block;
	}
	.wb_main{
		margin-left: 10px;
		height: 30px;
		line-height: 30px;
	}
	
	.bkxq_wrapper{
		height: 45px;
		line-height: 45px;
	}
	.music{
		background: url(../../../../static/imgs/icon_music.png) 0 center no-repeat;
		background-size: 100%;
		width: 28px;
		height: 45px;
		float: left;
		margin-right: 14px;
		cursor: pointer;
	}
	.music_icon{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tits{margin-right: 14px;}
	.tits,.music_icon{
		font-size: 22px;
		line-height: 45px;
	}
	.music audio{
		display: none;
	}
	.bkxq_wrapper{
		width: 80px;
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		text-align: center;
		color: #f095b9;
		border-radius: 4px;
		border:1px solid #f095b9;
		background: #fff;
		margin-top: 8px;
		cursor: pointer;
		margin-right: 20px;
	}
	.xq_box{
		position: absolute;
		top: 0;
		left: 0;
		height: 500px;
		overflow:auto;
		background: url(../../../../static/imgs/xqbg.png) 0 0 no-repeat;
		background-attachment: scroll;
		box-sizing: border-box;
		background-size: cover;
		padding: 20px 25px 0;
		display: none;
		z-index: 99;
	}
	.xq_box::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_box::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_box::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.xq_del{
		position: absolute;
		top: 20px;
		right: 20px;
		width: 24px;
		height: 24px;
		background: url(../../../../static/imgs/xdel.png) 0 0 no-repeat;
		cursor: pointer;
	}
	.xq_list{
		margin-bottom: 20px;
	}
	.xqTit{
		font-size: 20px;
		line-height: 45px;
		margin-bottom: 10px;
	}
	.xqCon{
		line-height: 32px;
		margin-bottom: 10px;
		/* background: url(../../static/imgs/tn_cir.png) 0 13px no-repeat; */
		background-size: 8px;
	}
	.fixedclear:after{
		content: "";
		display: block;
		clear: both;
	}
	.imgsrc{
		margin-bottom: 10px;
	}
	.imgsrc img{
		max-width: 200px;
		max-height: 143px;
		display: inline-block;
		margin: 0 5px;
		border:none;
	}
	.zcir{
		animation: go 1.5s infinite; 
		animation-fill-mode:both;
	}
	@keyframes go{
		0%{
			transform: rotateZ(0);
		}
		100%{
			transform: rotateZ(360deg);
		}
	}
	.videoSrc{
	width: 255px;
	height: 160px;
	}
	.videoSrc video{
		width: 100%;
		height: 100%;
	}
	.xqImg{
		width: 255px;
		height: 160px;
	}
	.xqImg img{
		width:100%;
		height: 100%;
	}
	.mark_wrap{
		width: 100%;
		height: 100%;	
		background: rgb(245,245,245,0.55);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tishi_Infor{
		width:400px;
		height: 150px;
		font-size: 16px;
		background: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		font-family: "微软雅黑"
	}
	.tishi_btn{
		margin-top: 30px;
		cursor: pointer;
		width: 116px;
		height: 32px;
		background: #595DB5;
		text-align: center;
		line-height: 32px;
		border-radius: 4px;
		color: #fff;
	}
	.video-widy{
		width: 230px;
		height: 136px;
	}
	.video-widy video{
		max-width: 230px;
		max-height: 136px;
	}
</style>


// WEBPACK FOOTER //
// src/components/index/template/tep3.vue